import { render, staticRenderFns } from "./CompreDataStatics.vue?vue&type=template&id=1618fe72&scoped=true&"
import script from "./CompreDataStatics.vue?vue&type=script&lang=js&"
export * from "./CompreDataStatics.vue?vue&type=script&lang=js&"
import style0 from "./CompreDataStatics.vue?vue&type=style&index=0&id=1618fe72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618fe72",
  null
  
)

export default component.exports